import React, { PropTypes } from 'react';
import { Card, CardTitle, CardText } from 'react-toolbox/lib/card';
import { Button } from 'react-toolbox/lib/button';

import animateDots from '../../utils/animateDots';

export default class TechnologyScheme extends React.Component {
  static propTypes = {
    cl: PropTypes.func.isRequired,
    staticContent: PropTypes.object.isRequired
  };

  initRouteOne() {
    const target = this.refs.route1canvas;
    animateDots(target, {
      id: 'route1canvas',
      twoWayDirection: true,
      amount: 80,
      routes: [
        {
          direction: 'right',
          routeLength: 188,
          routeWidth: 60,
          top: 0,
          left: 0
        }
      ]
    });

    const target2 = this.refs.route2canvas;
    animateDots(target2, {
      id: 'route2canvas',
      twoWayDirection: true,
      amount: 50,
      routes: [
        {
          direction: 'right',
          routeLength: 184,
          routeWidth: 40,
          top: 0,
          left: 0
        }
      ]
    });

    const target3 = this.refs.route3canvas;
    animateDots(target3, {
      id: 'route3canvas',
      twoWayDirection: true,
      amount: 25,
      routes: [
        {
          direction: 'down',
          routeLength: 190,
          routeWidth: 20,
          top: 0,
          left: 0
        },
        {
          direction: 'right',
          routeLength: 110,
          routeWidth: 20,
          left: 0,
          top: 170
        }
      ]
    });

    const target4 = this.refs.route4canvas;
    animateDots(target4, {
      id: 'route4canvas',
      twoWayDirection: true,
      amount: 8,
      routes: [
        {
          direction: 'down',
          routeLength: 190,
          routeWidth: 20,
          top: 0,
          left: 80
        },
        {
          direction: 'left',
          routeLength: 104,
          routeWidth: 20,
          left: 0,
          top: 170
        }
      ]
    });
  }

  componentDidMount() {
    this.initRouteOne();
  }

  getSchemeDescription() {
    const { cl, staticContent } = this.props;
    return (
      <Card className={cl('schemeDescription')()}>
        <CardTitle
          className={cl('descriptionTitle')()}
          title={staticContent.schemeTab.description.title}
        />
        <CardText>
          <div
            dangerouslySetInnerHTML={{
              __html: staticContent.schemeTab.description.content
            }}
          />
        </CardText>
      </Card>
    );
  }

  render() {
    const { cl, staticContent } = this.props;

    return (
      <div>
        <div
          className={cl('mobileWarning').mix('visible-xs')}
          aria-hidden={true}
        >
          <div
            dangerouslySetInnerHTML={{
              __html: staticContent.schemeTab.warningMessage
            }}
          />
        </div>

        <div className="visible-xs" aria-hidden={true}>
          {this.getSchemeDescription()}
        </div>

        <div className={cl('scheme').mix('hidden-xs')}>
          <Card className={cl('schemeBox', { color: 'green' })()}>
            <div className={cl('boxTitle')}>
              {staticContent.schemeTab.schemeBoxes.green.title}
            </div>
            <CardText className={cl('boxPictures', { readers: true })()}>
              <Button
                className={cl('boxPicture', { avatar: 1 })()}
                ripple={false}
              />
              <Button
                className={cl('boxPicture', { avatar: 2 })()}
                ripple={false}
              />
              <Button
                className={cl('boxPicture', { avatar: 3 })()}
                ripple={false}
              />
              <Button
                className={cl('boxPicture', { avatar: 4 })()}
                ripple={false}
              />
              <Button
                className={cl('boxPicture', { avatar: 5 })()}
                ripple={false}
              />
              <Button
                className={cl('boxPicture', { avatar: 6 })()}
                ripple={false}
              />
              <Button
                className={cl('boxPicture', { avatar: 7 })()}
                ripple={false}
              />
              <Button
                className={cl('boxPicture', { avatar: 8 })()}
                ripple={false}
              />
            </CardText>
          </Card>
          <Card className={cl('schemeBox', { color: 'orange' })()}>
            <div className={cl('boxTitle')}>
              {staticContent.schemeTab.schemeBoxes.orange.title}
            </div>
            <CardText className={cl('boxText', { color: 'orange' })()}>
              <div
                dangerouslySetInnerHTML={{
                  __html: staticContent.schemeTab.schemeBoxes.orange.content
                }}
              />
            </CardText>
          </Card>
          <Card className={cl('schemeBox', { color: 'blue' })()}>
            <div className={cl('boxTitle')}>
              {staticContent.schemeTab.schemeBoxes.blue.title}
            </div>
            <CardText className={cl('boxText', { color: 'blue' })()}>
              <div
                dangerouslySetInnerHTML={{
                  __html: staticContent.schemeTab.schemeBoxes.blue.content
                }}
              />
            </CardText>
          </Card>
          <Card className={cl('schemeBox', { color: 'red' })()}>
            <div className={cl('boxTitle')}>
              {staticContent.schemeTab.schemeBoxes.red.title}
            </div>
            <CardText className={cl('boxPictures', { cms: true })()}>
              <Button
                className={cl('boxPicture', { content: 1 })()}
                ripple={false}
              />
              <Button
                className={cl('boxPicture', { content: 2 })()}
                ripple={false}
              />
              <Button
                className={cl('boxPicture', { content: 3 })()}
                ripple={false}
              />
              <Button
                className={cl('boxPicture', { content: 4 })()}
                ripple={false}
              />
              <Button
                className={cl('boxPicture', { content: 5 })()}
                ripple={false}
              />
              <Button
                className={cl('boxPicture', { content: 6 })()}
                ripple={false}
              />
              <Button
                className={cl('boxPicture', { content: 7 })()}
                ripple={false}
              />
              <Button
                className={cl('boxPicture', { content: 8 })()}
                ripple={false}
              />
            </CardText>
          </Card>

          {this.getSchemeDescription()}

          <div className={cl('schemeSubtitle', { type: '1', arrow: 'left' })}>
            <div
              dangerouslySetInnerHTML={{
                __html: staticContent.schemeTab.hints[0].content
              }}
            />
          </div>

          <div
            className={cl('schemeSubtitle', {
              type: '2',
              arrow: 'right'
            })}
          >
            <div
              dangerouslySetInnerHTML={{
                __html: staticContent.schemeTab.hints[1].content
              }}
            />
          </div>

          <div
            className={cl('schemeSubtitle', {
              type: '3',
              arrow: 'right'
            })}
          >
            <div
              dangerouslySetInnerHTML={{
                __html: staticContent.schemeTab.hints[2].content
              }}
            />
          </div>

          <div className={cl('schemeSubtitle', { type: '4', arrow: 'left' })}>
            <div
              dangerouslySetInnerHTML={{
                __html: staticContent.schemeTab.hints[3].content
              }}
            />
          </div>

          <div className={cl('route', { type: '1' })}>
            <canvas
              ref="route1canvas"
              id="route1canvas"
              width="188"
              height="60"
            />
          </div>
          <div className={cl('route', { type: '2' })}>
            <canvas
              ref="route2canvas"
              id="route2canvas"
              width="184"
              height="40"
            />
          </div>
          <div className={cl('route', { type: '3' })}>
            <canvas
              ref="route3canvas"
              id="route3canvas"
              width="110"
              height="190"
            />
          </div>
          <div className={cl('route', { type: '4' })}>
            <canvas
              ref="route4canvas"
              id="route4canvas"
              width="104"
              height="190"
            />
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ../src/components/technology/scheme.js